import { IData } from "../../../../api/modelAPI/detectedSensitiveWordLog"

type Props = {
    item: IData,
    setStates: Function,
    changeStatus: Function,
    loading:boolean
}
const ViewConfirmIgnore = ({ item, setStates, changeStatus,loading }: Props) => {

    const setIgnore = () => {
        let obj = {
            id: item?.id,
            state: "Ignore",
            description: ""
        }
        changeStatus(obj)
    }


    return (
        <div>
            <label>آیا از تغییر وضعیت به نادیده گرفتن مطمئن هستید؟</label>
            <div className="d-flex justify-content-center align-items-center footer-wrapper ">
                <div className="d-flex justify-content-between align-items-center  mt-3">
                    <button className="btn btn-primary" onClick={() => setIgnore()}>
                        {loading ?
                            <div className="spinner-border" role="status" aria-hidden="true"></div>
                            : 'بله'}
                    </button>
                    <button className="btn btn-default" onClick={() => setStates({ show: false })}>خیر</button>
                </div>
            </div>
        </div>
    )
}
export default ViewConfirmIgnore